import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import BaseRouter from "./routes";
import * as actions from "./store/actions/auth";
import { ThemeProvider, CSSReset, ChakraProvider } from "@chakra-ui/react";
import mainTheme from "./themes/mainTheme";

import "./assets/styles/globals.css";

import { QueryClient, QueryClientProvider } from "react-query";

const queryClient = new QueryClient();

class App extends Component {
  componentDidMount() {
    this.props.onTryAutoSignup();
  }

  render() {
    return (
      <Router>
        <QueryClientProvider client={queryClient}>
          <ChakraProvider theme={mainTheme}>
            <BaseRouter {...this.props} />
          </ChakraProvider>
        </QueryClientProvider>
      </Router>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
